export const FlowAuthType = {
    HTTP_BASIC: 'HTTP_BASIC',
    OAUTH2: 'OAUTH2',
    BUKKU: 'BUKKU',
};
